import { Button, Grid, IconButton, TextField } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import { Close } from '@mui/icons-material';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import React, { useContext, useEffect, useState } from 'react';
import AccountManager, { isValidEmail, sendCode } from '../../manager/AccountManager';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LOGIN_URL, MAIN_URL_WITH_SLASH } from '../../manager/GlobalManager';
import { INIT_LOGIN_STATE } from '../../manager/LoginManager';
import LoginContext from '../../context/LoginContext';

export default function DeleteAccountDialog({ setDeleteAccountFlag }) {
    const ltx = useContext(LoginContext);
    const navigate = useNavigate();
    const location = useLocation();

    const { t, i18n } = useTranslation();
    const lang = i18n.language;

    const [userEmail, setUserEmail] = useState(null);
    const [code, setCode] = useState(null);
    const [emailError, setEmailError] = useState('');
    const [codeError, setCodeError] = useState('');
    const [accountDeleted, setAccountDeleted] = useState(false);

    useEffect(() => {
        if (accountDeleted) {
            ltx.setEmailCookie('');
            ltx.setLoginUser(null);
            ltx.setWantDeleteAcc(false);
            setDeleteAccountFlag?.(false);
            navigate(MAIN_URL_WITH_SLASH + LOGIN_URL + location.search + location.hash);
        }
    }, [accountDeleted]);

    function checkLogin() {
        if (ltx.loginUser) {
            return true;
        } else {
            if (ltx.loginUser !== INIT_LOGIN_STATE) {
                ltx.setWantDeleteAcc(true);
                navigate(MAIN_URL_WITH_SLASH + LOGIN_URL + location.hash);
                ltx.setOpenLoginMenu(true);
            }
        }
    }

    useEffect(() => {
        if (accountDeleted) {
            return;
        }
        const loggedIn = checkLogin();
        if (loggedIn) {
            if (ltx.loginUser !== INIT_LOGIN_STATE) {
                sendCode({
                    email: ltx.loginUser,
                    action: AccountManager.DELETE_EMAIL_MSG,
                    lang,
                }).then();
            }
        }
    }, [ltx.loginUser]);

    function close() {
        if (setDeleteAccountFlag) {
            setDeleteAccountFlag(false);
        } else {
            ltx.setWantDeleteAcc(false);
            navigate('/map/' + location.search + location.hash);
        }
    }

    return (
        ltx.isLoggedIn() && (
            <Dialog id="se-delete-account-dialog" open={true} onClose={close}>
                <Grid container spacing={2}>
                    <Grid item xs={11} sx={{ mb: -3 }}>
                        <DialogTitle>{t('web:delete_account_confirm')}</DialogTitle>
                    </Grid>
                    <Grid item xs={1} sx={{ ml: -2, mt: 1 }}>
                        <IconButton
                            variant="contained"
                            type="button"
                            onClick={() => {
                                setEmailError('');
                                close();
                            }}
                        >
                            <Close fontSize="small" />
                        </IconButton>
                    </Grid>
                </Grid>
                <DialogContent>
                    <DialogContentText>{t('web:delete_account_desc')}</DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        onChange={(e) => {
                            if (emailError !== '') {
                                setEmailError('');
                            }
                            setUserEmail(e.target.value);
                        }}
                        id="username-delete"
                        label={t('web:your_email_address')}
                        type="email"
                        fullWidth
                        variant="standard"
                        helperText={emailError ? emailError : ''}
                        error={emailError.length > 0}
                        value={userEmail ? userEmail : ''}
                    ></TextField>
                    <TextField
                        margin="dense"
                        onChange={(e) => {
                            setCodeError('');
                            setCode(e.target.value);
                        }}
                        id="code"
                        label={t('web:code_from_email')}
                        type="text"
                        fullWidth
                        variant="standard"
                        helperText={codeError}
                        error={codeError.length > 0}
                        value={code ?? ''}
                    ></TextField>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        component="span"
                        sx={{ backgroundColor: '#ff595e !important', ml: 2 }}
                        onClick={() => {
                            if (!isValidEmail(userEmail)) {
                                setEmailError(t('web:enter_valid_email'));
                            } else if (userEmail !== ltx.loginUser) {
                                setEmailError(t('web:email_does_not_match'));
                            } else {
                                AccountManager.deleteAccount({
                                    code,
                                    setError: setCodeError,
                                    setAccountDeleted,
                                }).then();
                            }
                        }}
                    >
                        {t('delete_account')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    );
}
